import dashboardOrchestrationServiceApi from "../services/dashboard-orchestration-service-api";
import DocOrchestrationService from "../services/dashboard-orchestration-service-api";
import { blobSignature, sasTokenExpiryHours } from "./general-config";
export const generateSasUriToken = async () => {
  return dashboardOrchestrationServiceApi
    .generateSasUriTokenForContainer(sasTokenExpiryHours)
    .then((response) => {
      if (!!response) {
        const token = new URL(response);
        return token.search;
      } else {
        return blobSignature();
      }
    })
    .catch((error) => {
      return blobSignature();
    });
};
